import * as React from 'react';

import { ApMenu } from '@alixpartners/ui-components';
import HeaderDropdownLabel from './HeaderDropdownLabel';
import { ApMenuItemStyled, CheckIcon } from './HeaderDropdown.styles';
import { IDropdownOption } from '../../utils/types';

export interface IHeaderDropdownProps {
  options: IDropdownOption[];
  selected: IDropdownOption;
  onChange: (option: IDropdownOption) => void;
}

export const HeaderDropdown = ({
  options,
  selected,
  onChange,
}: IHeaderDropdownProps) => (
  <ApMenu
    placement="bottom"
    button={<HeaderDropdownLabel>{selected.label}</HeaderDropdownLabel>}
  >
    {options.map((option) => (
      <ApMenuItemStyled
        key={`${option.label}-${option.value}`}
        onClick={() => {
          onChange(option);
        }}
        disabled={Boolean(option.disabled)}
        icon={
          <CheckIcon
            iconName="outline_done"
            visible={selected.value === option.value}
          />
        }
      >
        <div>{option.label}</div>
      </ApMenuItemStyled>
    ))}
  </ApMenu>
);

export default HeaderDropdown;
